module.exports = __webpack_public_path__ + "static/urban5-a38b5acba0c030cd62ffcfa14587352e.jpg";